import type { ReactNode } from 'react';

interface SectionHeaderProps {
  label: string;
  hint?: ReactNode;
  accent?: 'info' | 'accent' | 'ok' | 'warn' | 'crit';
}

const accentClass = {
  info: 'bg-[--color-info]',
  accent: 'bg-[--color-accent]',
  ok: 'bg-[--color-ok]',
  warn: 'bg-[--color-warn]',
  crit: 'bg-[--color-crit]',
} as const;

export function SectionHeader({ label, hint, accent = 'accent' }: SectionHeaderProps) {
  return (
    <div className="section-bar col-span-full">
      <span className={`h-2 w-2 rounded-full ${accentClass[accent]}`} aria-hidden />
      <span className="eyebrow !tracking-[0.2em] !text-[11px]">{label}</span>
      <span className="section-bar-line" />
      {hint && <span className="text-[11px] text-[--color-fg-muted]">{hint}</span>}
    </div>
  );
}
